function closestToSel(ci) {
  const res = {}
  res[ci.map] = [ci.id]
  return res
}
export default closestToSel
